<template>
  <v-dialog
    :title="$t('moveToMeetingTitle')"
    v-model="isMoveToDialog"
    width="350px"
    class="move-to-dialog"
    @click:outside="close"
    :modal-append-to-body="false"
  >
    <v-row no-gutters style="background-color: #21343b; justify-content: space-between" class="px-4 pt-5">
      <span class="txt-section-title ml-2">{{ $t('moveToMeetingTitle') }}</span>
      <v-btn dark elevation="0" icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-row>
    <div v-for="chType in Object.keys(chList)" :key="chType">
      <v-row
        v-if="
          (chType === 'private' && currentMt !== undefined && currentMt !== null
            ? isMtOrganizer
            : mtInfo.mtOrganizerUid === userInfo.userId) || chType !== 'private'
        "
        style="background-color: #21343b; margin: 0 !important"
        class="px-6 pt-3"
        no-gutters
        v-show="chType !== 'inbox'"
      >
        <v-col cols="auto" align="center" class="mb-3">
          <span style="font-size: 14px; color: #54646f">
            {{
              chType === 'workspace'
                ? $t('teamChannelTitle')
                : chType.charAt(0).toUpperCase() + chType.slice(1, chType.length)
            }}
          </span>
        </v-col>
      </v-row>
      <div
        v-if="
          (chType === 'private' && currentMt !== undefined && currentMt !== null
            ? isMtOrganizer
            : mtInfo.mtOrganizerUid === userInfo.userId) || chType !== 'private'
        "
      >
        <v-row
          class="ml-4 mr-4 mb-0 pb-3 px-2 bg-btn"
          @click="selectedCh['chId'] !== channel['chId'] ? (selectedNewCh = channel) : false"
          style="background-color: #21343b; margin: 0 !important"
          v-for="channel in chList[chType]"
          :key="channel['chId']"
        >
          <v-col class="my-0 pl-4 py-0 space" cols="10" color="white">{{ channel['chName'] }}</v-col>
          <v-col cols="2" class="mt-0 mb-0 pt-0 pb-0 pr-5" color="white" align-self="center" style="text-align: right">
            <v-icon color="primary" v-if="selectedNewCh['chId'] === channel['chId']">mdi-check</v-icon>
            <div
              color="primary"
              class="tag-current"
              v-if="selectedCh['chId'] === channel['chId'] || selectedCh['chId'] === channel['chId'].replace('CH:', '')"
            >
              Current
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row style="background-color: #21343b; margin: 0 !important">
      <v-col cols="12" class="px-5 pb-5 mt-2">
        <v-btn
          block
          class="btn-confirm white--text"
          color="rgb(40, 144, 103)"
          @click="confirm"
          :loading="isLoading"
          :disabled="!this.selectedNewCh['chId']"
        >
          {{ $t('confirm') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { changeMtChannel } from '@/services/channelApi'
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'

export default {
  name: 'MoveToDialog',
  props: ['isMoveToDialog', 'type', 'mtInfo'],
  created() {
    if (this.type && this.type !== null) this.spaceType = this.type.toLowerCase()
  },
  data() {
    return {
      selectedNewCh: {},
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters(['selectedWsInfo', 'chList', 'selectedCh', 'currentMt', 'isMtOrganizer', 'userInfo']),
  },
  methods: {
    async confirm() {
      this.isLoading = true
      let currentMtId =
        this.currentMt && this.currentMt !== null && this.currentMt !== undefined
          ? this.currentMt.mtId
          : this.mtInfo.mtId

      console.error('currentMtId', currentMtId)

      console.error(
        this.selectedWsInfo['wsId'],
        this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`,
        this.selectedNewCh['chId'].includes('CH:') ? this.selectedNewCh['chId'] : `CH:${this.selectedNewCh['chId']}`,
        currentMtId,
        this.selectedCh['chCategory'],
        this.selectedNewCh['chCategory']
      )

      try {
        let result = await changeMtChannel(
          this,
          this.selectedWsInfo['wsId'],
          this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`,
          this.selectedNewCh['chId'].includes('CH:') ? this.selectedNewCh['chId'] : `CH:${this.selectedNewCh['chId']}`,
          currentMtId,
          this.selectedCh['chCategory'],
          this.selectedNewCh['chCategory'],
          1
        )

        if (result) {
          // notify(this, 'Success', this.$t('updateSuccess'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('updateSuccess'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
          this.close()
          this.$router
            .replace({
              name: 'Channel',
              params: {
                wsDomain: this.selectedWsInfo['wsDomain'],
                chId: this.selectedNewCh['chId'].replace('CH:', ''),
              },
            })
            .catch(() => {})
          // this.$store.dispatch('setSelectedCh', {
          //   chType: this.selectedNewCh['chType'],
          //   chId: this.selectedNewCh['chId'].replace('CH:', ''),
          //   chIntegrationInfo: this.selectedNewCh['chIntegrationInfo'],
          // })
        } else {
          // notify(this, 'Error', this.$t('general.error'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.error'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } catch (error) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        console.log(error)
      } finally {
        this.isLoading = false
        this.$store.dispatch('getChannelList', {
          wsId: this.selectedWsInfo['wsId'],
        })
      }
    },
    close() {
      this.$emit('close', 'MoveToMeeting')
    },
  },
}
</script>

<style scoped>
.txt-section-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
span {
  color: white;
  font-weight: bold;
}
.bg-btn {
  background-color: #31434f;
  /* border-radius: 5px; */
  cursor: pointer;
}
.space {
  font-size: 15px;
  color: white;
  text-align: left;
  font-weight: 500;
}
.btn-confirm >>> .v-btn__loader {
  color: #25c685;
}
.btn-confirm:disabled >>> .v-btn__content {
  /* 응급조치 */
  color: #666;
}
.tag-current {
  display: inline-block;
  width: 60px;
  font-size: 12px;
  font-weight: 600;
  background-color: #999999;
  padding: 2px;
  border-radius: 5px;
  color: #21343b;
  text-align: center;
}
</style>
